export default __webpack_public_path__ + "static/media/voucher_mobile1.dafe0f3c.svg";